import React, { useEffect, useState } from "react";
import { Modal, ModalBody, Button } from "react-bootstrap";
import "./AddTransporterModal.css";
import { AddTransporter } from "../../services/tractorDataService";
import { toast } from "react-toastify";


function AddTransporterModal({show, onHide}) {

    const [transporterData, setTransporterData] = useState({
        TransporterName : "",
        Email : "",
        Type : ""
    })

    const [addButton, setAddButton] = useState("Add")
    const [disableBtn, setDisableBtn] = useState(true)

    function changeHandler(e) {
       setTransporterData({...transporterData, [e.target.name]:e.target.value}) 
    }

    useEffect(()=>{
      if(transporterData.TransporterName !== "" && transporterData.Email !== "" && (transporterData.Type === "to" || transporterData.Type === "cc")){
        setDisableBtn(false)
      }
      else{
        setDisableBtn(true)
      }
    },[transporterData])


    async function addHandler() {
        try {
            setAddButton("Adding...")
           await AddTransporter(transporterData)
           setAddButton("Add")
           setTransporterData({
            TransporterName : "",
            Email : "",
            Type : ""
           })
           toast.success("Transporter added successfully")
           onHide()
        } catch (error) {  
            setAddButton("Add")
           toast.error("Unable to add transporter...please try again")
        }
    }

    function cancelHadler() {
      onHide()
      setTransporterData({
        TransporterName : "",
        Email : "",
        Type : ""
       })
    }
  return (
    <>
      <Modal show={show} centered dialogClassName="modalClass">
        <ModalBody>
          <div className="transporterWindow__container">
            <div className="transporterWindow__header">
              <span className="transporterWindow__header_heading">Add Transporter</span>

              <button className="closeIcon" onClick={cancelHadler}>
              <i class="bx bxs-x-square"></i>
            </button>

              
            </div>
            <hr />
            
              <div className="transporterWindow__recipientName">
                <label className="transporterWindow__columnName_RecipientLabel">
                  Transporter Name - 
                </label>
                <input
                  type="text"
                  onChange={changeHandler}
                  value={transporterData.TransporterName}
                  className="transporterNameField"
                  name="TransporterName"
                />
              </div>
              
              
              
              {/* <div className="transporterWindow__recipientName">
                <label className="transporterWindow__columnName_RecipientLabel">
                Transporter Recepient (CC) -
                </label>
                <input
                  type="text"
                  onChange={changeHandler}
                  value={transporterData.transporterCCRecepient}
                  name="transporterCCRecepient"
                  className="transporterCCRecepientField"
                />
              </div> */}
              
              
            
            <div className="transporterWindow__recipientName">
                <label className="transporterWindow__columnName_RecipientLabel">
                Transporter Email -
                </label>
                <input
                  type="text"
                  onChange={changeHandler}
                  value={transporterData.Email}
                  name="Email"
                  className="transporterToRecepientField"
                />
              </div>
            <div className="emailWindow__recipientName">
                <label className="emailWindow__columnName_RecipientLabel">
                  To -
                </label>
                <input
                  type="checkbox"
                  onChange={changeHandler}
                  value="to"
                  checked={transporterData.Type === "to"}
                  name="Type"
                />
                <div className="emailWindow__recipientName">
                <label className="emailWindow__columnName_RecipientLabel">
                  CC -
                </label>
                <input
                  type="checkbox"
                  onChange={changeHandler}
                  value="cc"
                  name="Type"
                  checked={transporterData.Type === "cc"}
                />
              
              </div>
              </div>
              
            <div>
                <Button
                className="btn-primary btn-pill btn-sm mr1 sb addBtn"
                onClick={addHandler}
                disabled={disableBtn}
              >
                {addButton}

              </Button>
              </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
}
export default AddTransporterModal;
